<script setup lang="ts">
import { computed } from 'vue';
import { CompromissoForm } from '~/lib/fw';
import { useAuthenticationStore } from '~/stores/authenticationStore';

interface Props {
  compromisso?: any;
  fluxo?: any;
}

const props = defineProps<Props>();
const emit = defineEmits(['close']);

const authenticationStore = useAuthenticationStore();
const buttonsDisabled = computed(() => {
  return authenticationStore.user!.id !== props.compromisso.responsavelCodigo;
});
</script>

<template>
  <CompromissoForm
    action="custas/confirmar-envio-custas-para-pagamento"
    :compromisso-codigos="props.compromisso ? [props.compromisso.codigo] : []"
    :wait-for-result="true"
    :submit-button-disabled="buttonsDisabled"
    :devolver-button-visible="true"
    :devolver-button-disabled="buttonsDisabled"
    :show-upload-files="true"
    @close="() => emit('close')"
  >
    <template #form>
      <a-alert
        type="warning"
        message="Clique em salvar caso tenha enviado as custas para pagamento"
        style="margin-bottom: 24px"
        show-icon
      />
    </template>
  </CompromissoForm>
</template>
